var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "mr-2" },
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.onBack()
                    }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "chevron-left" }
                  }),
                  _vm._v("\n        Назад\n      ")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "mx-2" },
            [
              _vm.isBusy
                ? [
                    _c(
                      "h4",
                      {
                        staticClass: "mb-0",
                        attrs: { id: "task-ellipsis-loading" }
                      },
                      [_vm._v("Загрузка заявки")]
                    )
                  ]
                : [
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-2" },
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    [
                      _c("span", { staticClass: "text-small" }, [
                        _vm._v("Статус")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-badge",
                        {
                          attrs: {
                            pill: "",
                            variant: _vm.getStatusStyle(_vm.newItem.status_id)
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getStatusName(_vm.newItem.status_id)) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            id: "save-button",
                            size: "sm",
                            variant: "success",
                            disabled: _vm.isDisabled || _vm.loading
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleSubmit()
                            }
                          }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "save" }
                          }),
                          _vm._v("\n            Сохранить\n          ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasAnyMismatch
                        ? _c(
                            "b-tooltip",
                            {
                              key: "save-total-" + _vm.hasAnyMismatch,
                              attrs: {
                                target: "save-button",
                                variant: "warning"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Внимание: итого некоторых исполнителей не совпадает с суммой их услуг.\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-skeleton-wrapper", {
        attrs: { loading: _vm.isBusy },
        scopedSlots: _vm._u([
          {
            key: "loading",
            fn: function() {
              return [
                _c(
                  "b-card",
                  { attrs: { "no-body": "" } },
                  [
                    _c(
                      "b-card-body",
                      { staticClass: "p-3" },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-card",
                                  { attrs: { "no-body": "" } },
                                  [
                                    _c(
                                      "b-tabs",
                                      { attrs: { card: "" } },
                                      [
                                        _c("b-tab", {
                                          attrs: {
                                            title: "Основная информация",
                                            disabled: ""
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("b-tab", {
                                          attrs: {
                                            title: "Расходы",
                                            disabled: ""
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("b-tab", {
                                          attrs: {
                                            title: "Документы",
                                            disabled: ""
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-card",
                                      {
                                        staticClass: "m-3",
                                        attrs: { "bg-variant": "light" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              [
                                                _c(
                                                  "b-row",
                                                  { staticClass: "mt-2 mb-4" },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "17%",
                                                            height: "29%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "43%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "13%",
                                                            height: "29%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "43%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "24%",
                                                            height: "16%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "25%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-4",
                                                          attrs: {
                                                            width: "100%",
                                                            height: "14%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "29%",
                                                            height: "16%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "25%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  { staticClass: "pt-1" },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "60%",
                                                            height: "24%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "44%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "66%",
                                                            height: "24%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "44%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "75%",
                                                            height: "24%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "44%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "82%",
                                                            height: "24%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "44%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  { staticClass: "mt-1 mb-4" },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "42%",
                                                            height: "78%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("hr", {
                                                  staticClass: "mb-4"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "20%",
                                                            height: "24%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "43%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("hr", {
                                                  staticClass: "mb-4"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  { staticClass: "mb-2" },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "42%",
                                                            height: "24%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "45%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-row",
                                                  { staticClass: "pb-4" },
                                                  [
                                                    _c(
                                                      "b-col",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            width: "14%",
                                                            height: "24%"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("b-skeleton", {
                                                          attrs: {
                                                            type: "input",
                                                            width: "100%",
                                                            height: "77%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "5" } },
                              [
                                _c(
                                  "b-card",
                                  {
                                    attrs: {
                                      "no-body": "",
                                      "bg-variant": "light"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-card-header",
                                      { staticClass: "pt-3" },
                                      [
                                        _c("b-skeleton", {
                                          attrs: { width: "13%", height: "50%" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group",
                                      {
                                        attrs: {
                                          flush: "",
                                          "bg-variant": "light"
                                        }
                                      },
                                      _vm._l(11, function(i) {
                                        return _c(
                                          "b-list-group-item",
                                          {
                                            key: "skeleton-item-" + i,
                                            staticClass:
                                              "d-flex justify-content-between align-items-center",
                                            attrs: { "bg-variant": "light" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex-grow-1" },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "mb-0",
                                                  attrs: {
                                                    width: _vm.getLeftSkeletonWidth(
                                                      i
                                                    ),
                                                    height: "20%"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                i === 7 || i === 9 || i === 11
                                                  ? _c(
                                                      "span",
                                                      [
                                                        _c("b-skeleton", {
                                                          staticClass: "mt-2",
                                                          attrs: {
                                                            type: "text",
                                                            width: "45%"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "mr-5",
                                                  attrs: {
                                                    width: _vm.getRightSkeletonWidth(
                                                      i
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-card",
                  { attrs: { "no-body": "" } },
                  [
                    _c(
                      "b-card-header",
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { "align-v": "center", cols: "auto" } },
                              [
                                _c("h5", { staticClass: "text-muted" }, [
                                  _vm._v("Исполнители")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "mr-auto",
                                attrs: { cols: "auto" }
                              },
                              [
                                _c("b-skeleton", {
                                  attrs: {
                                    type: "input",
                                    width: "520%",
                                    height: "68%"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "auto" } },
                              [
                                _c("b-skeleton", {
                                  attrs: {
                                    type: "input",
                                    width: "260%",
                                    height: "68%"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "ml-5", attrs: { cols: "auto" } },
                              [
                                _c("b-skeleton", {
                                  attrs: {
                                    type: "input",
                                    width: "110%",
                                    height: "68%"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "mr-5", attrs: { cols: "auto" } },
                              [
                                _c("b-skeleton", {
                                  attrs: {
                                    type: "input",
                                    width: "250%",
                                    height: "68%"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { attrs: { "no-body": "", "bg-variant": "light" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-center text-muted d-flex align-items-center justify-content-center"
                          },
                          [
                            _c("div", { staticClass: "spinner" }, [
                              _c("div", { staticClass: "rect1" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "rect2" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "rect3" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "rect4" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "rect5" })
                            ]),
                            _vm._v(" "),
                            _c("h5", [_vm._v("Загрузка исполнителей")])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isBusy,
              expression: "!isBusy"
            }
          ]
        },
        [
          _c(
            "b-card",
            { attrs: { "no-body": "" } },
            [
              _c(
                "b-card-body",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-card",
                            { attrs: { "no-body": "" } },
                            [
                              _c(
                                "b-tabs",
                                { attrs: { card: "" } },
                                [
                                  _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title: "Основная информация",
                                        active: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card",
                                        { attrs: { "bg-variant": "light" } },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "groupLocation",
                                                        label: "Объект"
                                                      }
                                                    },
                                                    [
                                                      _c("location-select", {
                                                        ref: "location_select",
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          id:
                                                            "input-location-select",
                                                          "is-disabled":
                                                            _vm.isDisabled,
                                                          state: _vm.getFieldState(
                                                            "location_id"
                                                          )
                                                        },
                                                        on: {
                                                          onSelect:
                                                            _vm.onLocationChange
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id:
                                                          "group_start_address",
                                                        label: _vm.$t(
                                                          "message.tasks.modal.start_address"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id:
                                                            "input_start_address",
                                                          size: "sm",
                                                          type: "text",
                                                          disabled:
                                                            _vm.isDisabled,
                                                          state: _vm.getFieldState(
                                                            "start_address"
                                                          ),
                                                          placeholder: _vm.$t(
                                                            "message.tasks.modal.start_addressPlaceholder"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem
                                                              .start_address,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "start_address",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.start_address"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "groupExecutor",
                                                        label: "Менеджер",
                                                        description: _vm.userSelectDescription()
                                                      }
                                                    },
                                                    [
                                                      _c("user-select", {
                                                        ref: "user_select",
                                                        staticClass:
                                                          "mr-2 flex-fill",
                                                        attrs: {
                                                          id:
                                                            "input-user-select",
                                                          "is-disabled":
                                                            _vm.isDisabled ||
                                                            _vm.newItem
                                                              .location_id === 0
                                                        },
                                                        on: {
                                                          onSelect:
                                                            _vm.onSelectExecutor
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "groupProject",
                                                        label: "Руководитель"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "b-card",
                                                        {
                                                          attrs: {
                                                            "no-body": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "my-1 mx-2 text-small"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm.newItem
                                                                      .project_id !=
                                                                      null
                                                                      ? _vm
                                                                          .newItem
                                                                          .project_name
                                                                      : "-"
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "group_startDate",
                                                        label: _vm.$t(
                                                          "message.tasks.modal.start_date"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: "input_startDate",
                                                          size: "sm",
                                                          type: "date",
                                                          disabled:
                                                            _vm.isDisabled,
                                                          placeholder: _vm.$t(
                                                            "message.tasks.modal.start_datePlaceholder"
                                                          )
                                                        },
                                                        model: {
                                                          value: _vm.startDate,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.startDate = $$v
                                                          },
                                                          expression:
                                                            "startDate"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "group_startTime",
                                                        label: _vm.$t(
                                                          "message.tasks.modal.start_time"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: "input_startTime",
                                                          size: "sm",
                                                          type: "time",
                                                          disabled:
                                                            _vm.isDisabled
                                                        },
                                                        model: {
                                                          value: _vm.startTime,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.startTime = $$v
                                                          },
                                                          expression:
                                                            "startTime"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "group_endDate",
                                                        label: _vm.$t(
                                                          "message.tasks.modal.end_date"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: "input_endDate",
                                                          size: "sm",
                                                          type: "date",
                                                          disabled:
                                                            _vm.isDisabled
                                                        },
                                                        model: {
                                                          value: _vm.endDate,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.endDate = $$v
                                                          },
                                                          expression: "endDate"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "group_endTime",
                                                        label: _vm.$t(
                                                          "message.tasks.modal.end_time"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: "input_endTime",
                                                          size: "sm",
                                                          type: "time",
                                                          disabled:
                                                            _vm.isDisabled
                                                        },
                                                        model: {
                                                          value: _vm.endTime,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.endTime = $$v
                                                          },
                                                          expression: "endTime"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "mb-3",
                                              attrs: {
                                                size: "sm",
                                                variant: "primary",
                                                disabled: _vm.isDisabled
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.setWorkersDateTapped()
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "mr-1",
                                                attrs: { icon: "business-time" }
                                              }),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    "Установить дату и время исполнителям"
                                                  ) +
                                                  "\n                    "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id: "group_work_type",
                                                        label:
                                                          "Вид работ объекта"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "location-works-select",
                                                        {
                                                          ref:
                                                            "location_works_select",
                                                          attrs: {
                                                            id:
                                                              "location-works-select",
                                                            "is-disabled":
                                                              _vm.isDisabled,
                                                            state: _vm.getFieldState(
                                                              "task_location_works"
                                                            )
                                                          },
                                                          on: {
                                                            onSelect:
                                                              _vm.onLocationWorkSelect
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("hr"),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id:
                                                          "group_workers_count",
                                                        label:
                                                          "Планируемое количество исполнителей"
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id:
                                                            "input_workers_count",
                                                          size: "sm",
                                                          type: "number",
                                                          min: "0",
                                                          disabled: _vm.isPlanWorkersCountDisabled(),
                                                          state: _vm.getFieldState(
                                                            "plan_workers_count"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem
                                                              .plan_workers_count,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "plan_workers_count",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.plan_workers_count"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group_cargo_description",
                                                label: "Примечание"
                                              }
                                            },
                                            [
                                              _c("b-form-textarea", {
                                                attrs: {
                                                  id:
                                                    "textarea_cargo_description",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Примечание",
                                                  rows: 2,
                                                  "max-rows": 2,
                                                  "no-resize": ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .cargo_description,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "cargo_description",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.cargo_description"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    { attrs: { title: "Расходы" } },
                                    [
                                      _c(
                                        "b-card",
                                        { attrs: { "bg-variant": "light" } },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id:
                                                          "group_additional_cost",
                                                        label: _vm.$t(
                                                          "message.tasks.modal.additional_cost"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id:
                                                            "input_additional_cost",
                                                          size: "sm",
                                                          type: "number",
                                                          disabled:
                                                            _vm.isDisabled
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem
                                                              .additional_cost,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "additional_cost",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.additional_cost"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id:
                                                          "group_additional_income",
                                                        label: _vm.$t(
                                                          "message.tasks.modal.additional_income"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id:
                                                            "input_additional_income",
                                                          size: "sm",
                                                          type: "number",
                                                          disabled:
                                                            _vm.isDisabled
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem
                                                              .additional_income,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "additional_income",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.additional_income"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        id:
                                                          "group_declarated_cost",
                                                        label: _vm.$t(
                                                          "message.tasks.modal.declarated_cost"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id:
                                                            "input_declarated_cost",
                                                          size: "sm",
                                                          type: "number",
                                                          disabled:
                                                            _vm.isDisabled
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem
                                                              .declarated_cost,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "declarated_cost",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.declarated_cost"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group_description",
                                                label: _vm.$t(
                                                  "message.tasks.modal.description"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-textarea", {
                                                attrs: {
                                                  id: "textarea_description",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: _vm.$t(
                                                    "message.tasks.modal.descriptionPlaceholder"
                                                  ),
                                                  rows: 2,
                                                  "max-rows": 2,
                                                  "no-resize": ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.description,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "description",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.description"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    { attrs: { title: "Документы" } },
                                    [
                                      _c("task-files", {
                                        ref: "task_files",
                                        attrs: { "is-disabled": _vm.isDisabled }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "5" } },
                        [
                          _c(
                            "b-card",
                            { attrs: { "no-body": "", "bg-variant": "light" } },
                            [
                              _c("b-card-header", [
                                _c("h6", { attrs: { id: "task-header" } }, [
                                  _vm._v("Итого")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                { attrs: { flush: "", "bg-variant": "light" } },
                                [
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Заказчик\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.customer.name))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Объект\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.location.name))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Стоимость за единицу\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.newItem.payment_first)
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.getTotalTitle()) +
                                          "\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.newItem.total_hours
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Сумма с заказчика\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.newItem.total_price
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Исполнителям\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.newItem.total_worker_price
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "\n                    Исполнителям\n                    "
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-small text-secondary"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      с учетом коммиссии сервиса "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.newItem.smz_cost) +
                                                  "%"
                                              )
                                            ])
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.newItem
                                                .total_worker_price_with_comiss
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.tasks.modal.total_delta"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.newItem.total_delta
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "\n                    Маржинальность\n                    "
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-small text-secondary"
                                          },
                                          [
                                            _vm._v(
                                              "без учета расходов за месяц"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.marginality) + " %")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Менеджеру\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.newItem.total_manager
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.visibleProject()
                                    ? _c(
                                        "b-list-group-item",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center"
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              "\n                    Руководителю\n                    "
                                            ),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-small text-secondary"
                                              },
                                              [
                                                _vm._v(
                                                  "без учета расходов за месяц"
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.newItem.project_id != null
                                                  ? _vm.priceFormat(
                                                      _vm.newItem.total_project
                                                    )
                                                  : "-"
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            { attrs: { "no-body": "" } },
            [
              _c(
                "b-card-header",
                [
                  _c(
                    "b-row",
                    { attrs: { "align-v": "center" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mr-auto", attrs: { cols: "auto" } },
                        [
                          _c("h5", { staticClass: "mb-0" }, [
                            _vm._v("Исполнители")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mr-auto" },
                        [
                          _c(
                            "b-button",
                            {
                              ref: "allWorkerPriceButton",
                              attrs: {
                                id: "allWorkerPriceButton",
                                size: "sm",
                                variant: "primary",
                                disabled: _vm.isDisabled
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "money-check-alt" }
                              }),
                              _vm._v("\n              Назначить\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("export-sidebar", {
                            attrs: {
                              "sidebar-id": "sidebar-task-workers-export",
                              "storage-key": "sidebar_task_workers_export",
                              columns: _vm.exportableFields,
                              "data-to-export": _vm.dataToExport,
                              "data-mapper": _vm.mapTaskForExport,
                              "file-name": "TaskWorkers.xlsx",
                              "sheet-name": "TaskWorkers",
                              "is-busy": _vm.isBusy,
                              "items-count": _vm.totalTWRows
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.sidebar-fields",
                                  modifiers: { "sidebar-fields": true }
                                }
                              ],
                              staticClass: "mr-1",
                              attrs: {
                                id: "table-settings",
                                size: "sm",
                                variant: "warning"
                              },
                              on: { click: _vm.onPopoverClose }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "cog" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tooltip",
                            {
                              attrs: {
                                target: "table-settings",
                                triggers: "hover",
                                variant: "warning",
                                noninteractive: ""
                              }
                            },
                            [_vm._v("\n              Колонки\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isDisabled
                              },
                              on: { click: _vm.showFreeWorkers }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: ["fas", "plus"] }
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("message.workers.importHand")) +
                                  "\n            "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-table", {
                ref: "TaskWorkers",
                staticClass: "mb-0 text-small",
                attrs: {
                  id: "workers",
                  "tbody-tr-class": _vm.tbodyRowClass,
                  "select-mode": "multi",
                  striped: "",
                  small: "",
                  "thead-class": "fixed-top-thead thead-light",
                  responsive: "",
                  "show-empty": "",
                  "empty-text": _vm.$t("message.common.emptyTable"),
                  items: _vm.newItem.task_workers,
                  fields: _vm.renderedFields,
                  "current-page": _vm.currentPage,
                  "per-page": _vm.perPage,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc
                },
                on: {
                  "update:sortBy": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function($event) {
                    _vm.sortDesc = $event
                  },
                  "row-clicked": _vm.onRowClicked
                },
                scopedSlots: _vm._u([
                  {
                    key: "head(selected)",
                    fn: function(row) {
                      return [
                        _c("b-form-checkbox", {
                          staticClass: "mx-1",
                          attrs: {
                            indeterminate: _vm.indeterminate,
                            size: "md"
                          },
                          on: { change: _vm.selectPageRows },
                          model: {
                            value: _vm.allSelected,
                            callback: function($$v) {
                              _vm.allSelected = $$v
                            },
                            expression: "allSelected"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(selected)",
                    fn: function(row) {
                      return [
                        row.item.selected
                          ? [
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("✓")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("Выбрана")
                              ])
                            ]
                          : [
                              _c("span", [_vm._v(" ")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("Не выбрана")
                              ])
                            ]
                      ]
                    }
                  },
                  {
                    key: "cell(name)",
                    fn: function(row) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.item.name) +
                            "\n          "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        row.item.inn != null
                          ? _c(
                              "div",
                              {
                                staticClass: "m-0 p-0 text-secondary text-small"
                              },
                              [_vm._v("ИНН: " + _vm._s(row.item.inn))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "m-0 p-0 text-small",
                            attrs: { href: _vm.telUrl(row.item.phone) }
                          },
                          [_vm._v(_vm._s(_vm.phoneString(row.item.phone)))]
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(price)",
                    fn: function(row) {
                      return [
                        _c("b-form-input", {
                          attrs: {
                            id: "input_price1",
                            type: "number",
                            min: 0,
                            disabled: _vm.isDisabled,
                            size: "sm",
                            autocomplete: "off"
                          },
                          on: { keydown: _vm.preventMinus },
                          model: {
                            value: row.item.price,
                            callback: function($$v) {
                              _vm.$set(row.item, "price", _vm._n($$v))
                            },
                            expression: "row.item.price"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(start_date)",
                    fn: function(row) {
                      return [
                        _c(
                          "b-form",
                          { attrs: { inline: "" } },
                          [
                            _c("b-form-input", {
                              staticClass: "mr-1",
                              attrs: {
                                id: "input_startDate1",
                                type: "date",
                                disabled: _vm.isDisabled,
                                size: "sm"
                              },
                              model: {
                                value: row.item.string_start_date,
                                callback: function($$v) {
                                  _vm.$set(row.item, "string_start_date", $$v)
                                },
                                expression: "row.item.string_start_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                id: "input_startTime1",
                                type: "time",
                                disabled: _vm.isDisabled,
                                size: "sm"
                              },
                              model: {
                                value: row.item.start_time,
                                callback: function($$v) {
                                  _vm.$set(row.item, "start_time", $$v)
                                },
                                expression: "row.item.start_time"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(end_date)",
                    fn: function(row) {
                      return [
                        _c(
                          "b-form",
                          { attrs: { inline: "" } },
                          [
                            _c("b-form-input", {
                              staticClass: "mr-1",
                              attrs: {
                                id: "input_endDate1",
                                type: "date",
                                disabled: _vm.isDisabled,
                                size: "sm"
                              },
                              model: {
                                value: row.item.string_end_date,
                                callback: function($$v) {
                                  _vm.$set(row.item, "string_end_date", $$v)
                                },
                                expression: "row.item.string_end_date"
                              }
                            }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                id: "input_endTime1",
                                type: "time",
                                disabled: _vm.isDisabled,
                                size: "sm"
                              },
                              model: {
                                value: row.item.end_time,
                                callback: function($$v) {
                                  _vm.$set(row.item, "end_time", $$v)
                                },
                                expression: "row.item.end_time"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(road_price)",
                    fn: function(row) {
                      return [
                        _c("b-form-input", {
                          attrs: {
                            id: "input_price",
                            type: "number",
                            disabled: _vm.isDisabled,
                            size: "sm",
                            autocomplete: "off"
                          },
                          model: {
                            value: row.item.road_price,
                            callback: function($$v) {
                              _vm.$set(row.item, "road_price", _vm._n($$v))
                            },
                            expression: "row.item.road_price"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(dinner)",
                    fn: function(row) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column align-items-center"
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "dinner-number-input mb-1",
                              attrs: {
                                id: "input_dinner",
                                type: "number",
                                disabled: _vm.isDisabled,
                                step: "0.5",
                                size: "sm",
                                autocomplete: "off"
                              },
                              model: {
                                value: row.item.dinner,
                                callback: function($$v) {
                                  _vm.$set(row.item, "dinner", _vm._n($$v))
                                },
                                expression: "row.item.dinner"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "dinner-time-field" }, [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm dinner-time-input",
                                attrs: {
                                  type: "text",
                                  disabled: _vm.isDisabled
                                },
                                domProps: {
                                  value: _vm.toHHMM(row.item.dinner)
                                },
                                on: {
                                  change: function(e) {
                                    return (row.item.dinner = _vm.fromHHMM(
                                      e.target.value
                                    ))
                                  },
                                  keydown: [
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "up",
                                          38,
                                          $event.key,
                                          ["Up", "ArrowUp"]
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.stepDinner(row.item, 5)
                                    },
                                    function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "down",
                                          40,
                                          $event.key,
                                          ["Down", "ArrowDown"]
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      return _vm.stepDinner(row.item, -5)
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "dinner-time-arrows" },
                                [
                                  _c(
                                    "button",
                                    {
                                      attrs: {
                                        type: "button",
                                        tabindex: "-1",
                                        disabled: _vm.isDisabled
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.stepDinner(row.item, 5)
                                        }
                                      }
                                    },
                                    [_vm._v("▲")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      attrs: {
                                        type: "button",
                                        tabindex: "-1",
                                        disabled: _vm.isDisabled
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.stepDinner(row.item, -5)
                                        }
                                      }
                                    },
                                    [_vm._v("▼")]
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(prepaid)",
                    fn: function(row) {
                      return [
                        _c("b-form-input", {
                          attrs: {
                            id: "input_prepaid",
                            type: "number",
                            disabled: _vm.isDisabled,
                            size: "sm",
                            autocomplete: "off"
                          },
                          model: {
                            value: row.item.prepaid,
                            callback: function($$v) {
                              _vm.$set(row.item, "prepaid", _vm._n($$v))
                            },
                            expression: "row.item.prepaid"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(total_units)",
                    fn: function(row) {
                      return [
                        _vm.newItem.unit_code === "539"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-column align-items-center text-center"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold mb-2" },
                                  [_vm._v(_vm._s(row.item.total_units))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "text-muted small" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDecimalToTime(
                                          row.item.total_units
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          : _c(
                              "div",
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_total_units",
                                    type: "number",
                                    disabled: _vm.isDisabled,
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.total_units,
                                    callback: function($$v) {
                                      _vm.$set(
                                        row.item,
                                        "total_units",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "row.item.total_units"
                                  }
                                })
                              ],
                              1
                            )
                      ]
                    }
                  },
                  {
                    key: "cell(total_price)",
                    fn: function(row) {
                      return [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  title: _vm.mismatchingTotals.includes(
                                    row.item.worker_id
                                  )
                                    ? _vm.getTooltipTitle(row.item)
                                    : "",
                                  variant: "danger",
                                  placement: "auto",
                                  triggers: "hover"
                                },
                                expression:
                                  "{\n            title: mismatchingTotals.includes(row.item.worker_id) ? getTooltipTitle(row.item) : '',\n            variant: 'danger',\n            placement: 'auto',\n            triggers: 'hover'\n            }"
                              }
                            ],
                            class: {
                              "text-danger font-weight-bold": _vm.mismatchingTotals.includes(
                                row.item.worker_id
                              )
                            },
                            attrs: { id: "total-price-" + row.item.worker_id }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.priceFormat(row.item.total_price)) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(description)",
                    fn: function(row) {
                      return [
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea_descriptionq",
                            disabled: _vm.isDisabled,
                            placeholder: _vm.$t(
                              "message.tasks.modal.descriptionPlaceholder"
                            ),
                            rows: 2,
                            "max-rows": 2,
                            size: "sm"
                          },
                          model: {
                            value: row.item.description,
                            callback: function($$v) {
                              _vm.$set(row.item, "description", $$v)
                            },
                            expression: "row.item.description"
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "cell(paid)",
                    fn: function(row) {
                      return [
                        _vm.visibleAdmins()
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "button",
                                      size: "sm",
                                      variant: _vm.getPaidVariant(row),
                                      disabled:
                                        _vm.isDisabled ||
                                        _vm.newItem.status_id === 1
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.showModalAccept(row)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.getPaidTitle(row)) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                row.item.paid &&
                                row.item.has_integration_details
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "info",
                                          disabled: _vm.isDisabled
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onPaidDetails(row)
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "info" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.getPaidTitle(row)) +
                                    "\n            "
                                ),
                                row.item.paid
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "info",
                                          disabled: _vm.isDisabled
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onPaidDetails(row)
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "info" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                      ]
                    }
                  },
                  {
                    key: "cell(action)",
                    fn: function(row) {
                      return [
                        _c(
                          "b-button-group",
                          { attrs: { size: "sm" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mr-1",
                                attrs: {
                                  id: "tws-details",
                                  size: "sm",
                                  variant: row.detailsShowing
                                    ? "secondary"
                                    : "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return row.toggleDetails()
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: row.detailsShowing
                                      ? "clipboard"
                                      : "clipboard-list"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  size: "sm",
                                  variant: "danger",
                                  disabled: _vm.isDisabled
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onRemove(row)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "trash" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "row-details",
                    fn: function(row) {
                      return [
                        _c(
                          "b-card",
                          {
                            staticClass: "border-secondary m-2",
                            attrs: { "no-body": "" }
                          },
                          [
                            _c("task-worker-services", {
                              ref: "task_worker_services",
                              attrs: {
                                tws: row.item.task_worker_services,
                                tw: row.item,
                                "tws-options": _vm.locationWorkServices
                              },
                              on: {
                                change: function($event) {
                                  row.item.task_worker_services = $event
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c(
                "b-card-footer",
                { attrs: { "footer-bg-variant": "light" } },
                [
                  _c(
                    "b-row",
                    { attrs: { "align-h": "between", "align-v": "center" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mr-auto", attrs: { cols: "auto" } },
                        [
                          _vm._v("\n            Всего исполнителей: "),
                          _c("b", [_vm._v(_vm._s(_vm.totalTWRows))])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("b-pagination", {
                            attrs: {
                              id: "pagination",
                              pills: "",
                              "total-rows": _vm.totalTWRows,
                              "per-page": _vm.perPage
                            },
                            model: {
                              value: _vm.currentPage,
                              callback: function($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("workers-free", {
            ref: "freeWorkersTable",
            attrs: {
              date: _vm.getStartDateTime(),
              end_date: _vm.getEndDateTime(),
              workers: _vm.newItem.task_workers
            },
            on: { addToTask: _vm.addToTask }
          }),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "modalAccept",
              attrs: {
                id: "modal-accept",
                title: _vm.$t("message.tasks.modal.acceptWorkerTitle"),
                "ok-title": _vm.$t("message.actions.ok"),
                "cancel-title": _vm.$t("message.actions.cancel"),
                centered: ""
              },
              on: {
                ok: function($event) {
                  return _vm.acceptItem()
                }
              }
            },
            [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("message.tasks.modal.acceptWorkerDesc")) +
                    ' "' +
                    _vm._s(_vm.acceptWorker.name) +
                    '"'
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-popover",
            {
              ref: "popover",
              attrs: {
                target: "allWorkerPriceButton",
                triggers: "click",
                show: _vm.popoverShow,
                placement: "auto",
                container: "my-container"
              },
              on: {
                "update:show": function($event) {
                  _vm.popoverShow = $event
                },
                show: _vm.onShow,
                shown: _vm.onShown,
                hidden: _vm.onHidden
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center w-100"
                        },
                        [
                          _c(
                            "small",
                            { staticClass: "font-weight-bold text-muted" },
                            [_vm._v("Назначить исполнителям")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "close pb-1",
                              attrs: { "aria-label": "Close" },
                              on: { click: _vm.onPopoverClose }
                            },
                            [
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-1",
                      attrs: {
                        label: "Ставка",
                        "label-for": "allWorkerPriceInput",
                        "label-cols": "3"
                      }
                    },
                    [
                      _c("b-form-input", {
                        ref: "allWorkerPriceInput",
                        attrs: {
                          id: "allWorkerPriceInput",
                          type: "number",
                          placeholder: "Введите ставку",
                          size: "sm"
                        },
                        model: {
                          value: _vm.allWorkerPriceModel,
                          callback: function($$v) {
                            _vm.allWorkerPriceModel = _vm._n($$v)
                          },
                          expression: "allWorkerPriceModel"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Обед", "label-cols": "3" } },
                    [
                      _c("b-form-input", {
                        ref: "allWorkerDinnerInput",
                        attrs: {
                          type: "number",
                          placeholder: "Введите обед",
                          size: "sm"
                        },
                        model: {
                          value: _vm.allWorkerDinnerModel,
                          callback: function($$v) {
                            _vm.allWorkerDinnerModel = _vm._n($$v)
                          },
                          expression: "allWorkerDinnerModel"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Услуги СМЗ", "label-cols": "3" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-1",
                                  attrs: { label: "Услуга" }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.locationWorkServices,
                                      size: "sm"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "first",
                                        fn: function() {
                                          return [
                                            _c(
                                              "b-form-select-option",
                                              {
                                                attrs: {
                                                  value: null,
                                                  disabled: ""
                                                }
                                              },
                                              [_vm._v("Выберите услугу")]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ]),
                                    model: {
                                      value: _vm.allSmzWorkerServiceSelected,
                                      callback: function($$v) {
                                        _vm.allSmzWorkerServiceSelected = $$v
                                      },
                                      expression: "allSmzWorkerServiceSelected"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: { label: "Количество" }
                                },
                                [
                                  _c("b-form-input", {
                                    ref: "allSmzWorkerServiceQuantityInput",
                                    attrs: {
                                      type: "number",
                                      placeholder: "Введите количество",
                                      size: "sm"
                                    },
                                    model: {
                                      value: _vm.allSmzWorkerServiceQuantity,
                                      callback: function($$v) {
                                        _vm.allSmzWorkerServiceQuantity = _vm._n(
                                          $$v
                                        )
                                      },
                                      expression: "allSmzWorkerServiceQuantity"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1",
                          attrs: { size: "sm", variant: "secondary" },
                          on: { click: _vm.onPopoverClose }
                        },
                        [_vm._v("Закрыть")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "success" },
                          on: { click: _vm.onPopoverOk }
                        },
                        [_vm._v("Назначить")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "modalTWDetails",
              attrs: {
                id: "modal-tw-details",
                title: "Детали оплаты",
                "ok-only": "",
                size: "lg"
              }
            },
            [
              _vm.twDetails != null
                ? _c(
                    "div",
                    [
                      _c(
                        "b-list-group",
                        { attrs: { flush: "", "bg-variant": "light" } },
                        [
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                              attrs: { "bg-variant": "light" }
                            },
                            [
                              _vm._v("\n            Задание\n            "),
                              _c("strong", [
                                _vm._v(_vm._s(this.twDetails.name))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                              attrs: { "bg-variant": "light" }
                            },
                            [
                              _vm._v("\n            Описание\n            "),
                              _c("strong", [
                                _vm._v(_vm._s(this.twDetails.description))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                              attrs: { "bg-variant": "light" }
                            },
                            [
                              _vm._v("\n            Стоимость\n            "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.priceFormat(this.twDetails.price)
                                  ) + " ₽"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                              attrs: { "bg-variant": "light" }
                            },
                            [
                              _vm._v("\n            Статус\n            "),
                              _c("strong", [
                                _vm._v(_vm._s(this.twDetails.status))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center"
                            },
                            [
                              _vm._v(
                                "\n            Дата создания\n            "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(this.twDetails.created_at))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                              attrs: { "bg-variant": "light" }
                            },
                            [
                              _vm._v("\n            Договор\n            "),
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href: this.twDetails.contract.url,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(this.twDetails.contract.name))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                              attrs: { "bg-variant": "light" }
                            },
                            [
                              _vm._v("\n            Акт\n            "),
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href: this.twDetails.act.url,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(this.twDetails.act.name))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                              attrs: { "bg-variant": "light" }
                            },
                            [
                              _vm._v("\n            Чек\n            "),
                              _c(
                                "b-link",
                                {
                                  attrs: {
                                    href: this.twDetails.act.receipt.link,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Открыть")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center"
                            },
                            [
                              _vm._v(
                                "\n            Статус оплаты\n            "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(this.twDetails.act.status_pay))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center"
                            },
                            [
                              _vm._v(
                                "\n            Оплачено исполнителю\n            "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.priceFormat(this.twDetails.act.sum)
                                  ) + " ₽"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center"
                            },
                            [
                              _vm._v(
                                "\n            Удержанный налог\n            "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.priceFormat(this.twDetails.act.tax)
                                  ) + " ₽"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center"
                            },
                            [
                              _vm._v(
                                "\n            Комиссия сервиса\n            "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.priceFormat(
                                      this.twDetails.act.commission
                                    )
                                  ) + " ₽"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center"
                            },
                            [
                              _vm._v("\n            Дата оплаты\n            "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatTableDateTime(
                                      new Date(
                                        this.twDetails.act.receipt.created_time
                                      )
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "taskWorkers_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fieldsTW,
          fieldKey: "name"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fieldsTW = $event
          },
          "update:fields-model": function($event) {
            _vm.fieldsTW = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02ab2294", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ab2294","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/Task.vue
// module id = null
// module chunks = 